import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { shallowCompare } from '@famly/vet_ts-utils_generic-hooks';
import { hasValue } from '@famly/vet_ts-utils_typescript';
export function useQueryParams(queryParamNames) {
    const computedQueryParams = useComputeQueryParams(queryParamNames);
    const [queryParams, setQueryParams] = useState(computedQueryParams);
    /**
     * Compare computed query parameters with state to avoid updates with
     * equal values.
     */
    useEffect(() => {
        if (shallowCompare(queryParams, computedQueryParams)) {
            setQueryParams(computedQueryParams);
        }
    }, [computedQueryParams, queryParams]);
    return queryParams;
}
const useComputeQueryParams = (queryParamNames) => {
    const initial = {};
    // `useLocation()` throws an error if used outside of the React router.
    try {
        const location = useLocation();
        const queryParams = new URLSearchParams(location.search);
        if (!hasValue(queryParamNames)) {
            const obj = {};
            queryParams.forEach((value, key) => {
                if (hasValue(obj[key])) {
                    obj[key] = obj[key] instanceof Array ? [...obj[key], value] : [obj[key], value];
                }
                else {
                    obj[key] = value;
                }
            });
            return obj;
        }
        return queryParamNames.reduce((reduction, queryParamName) => {
            reduction[queryParamName] = queryParams.get(queryParamName);
            return reduction;
        }, initial);
    }
    catch (_a) {
        console.error('The useQueryParams hook can only be used within the context of a react router route.');
        return hasValue(queryParamNames) ? initial : {};
    }
};
